const t = {
  summary: 'summary',
  details: 'details',
  fullDescription: '[data-full-description]',
  showLessButton: '[data-show-less]',
  toggle: '[data-toggle]',
};
class l extends HTMLElement {
  constructor() {
    super(),
      (this.config = {animationDuration: 300}),
      (this.elements = {
        summary: this.querySelector(t.summary),
        details: this.querySelector(t.details),
        fullDescription: this.querySelector(t.fullDescription),
        showLessButton: this.querySelector(t.showLessButton),
        toggles: this.querySelectorAll(t.toggle),
      });
  }
  connectedCallback() {
    this.elements.summary.addEventListener('click', this.handleSummaryClick.bind(this)),
      this.elements.toggles.forEach((e) => {
        e.addEventListener('click', this.handleToggleClick.bind(this));
      }),
      (this.elements.details.style.animationDuration = `${this.config.animationDuration}ms`);
  }
  handleSummaryClick(e) {
    e.preventDefault(), this.toggleDescription(!0);
  }
  handleShowLessClick() {
    this.toggleDescription(!1);
  }
  handleToggleClick(e) {
    e.preventDefault(), this.toggleDescription(e.target.dataset.toggle === 'expand');
  }
  toggleDescription(e) {
    const s = e || !this.elements.details.open,
      i = this.elements.summary.scrollHeight;
    if (((this.elements.details.style.height = `${i}px`), s)) {
      (this.elements.details.open = !0),
        (this.elements.details.style.height = `${this.elements.details.scrollHeight}px`);
      return;
    }
    setTimeout(() => {
      this.elements.details.open = !1;
    }, this.config.animationDuration);
  }
}
function o() {
  customElements.get('product-description') || customElements.define('product-description', l);
}
export {o as i};
